<div class="modal-window__header">
  <div class="modal-window__title">
    {{ localizationConstants.APPROVED_SERVICE_PRICE_ADD_NEW_ITEM | translate }}
  </div>
  <a (click)="modalService.close()">
    <i class="c-icon c-icon--close-dark"></i>
  </a>
</div>
<form
  #f="ngForm"
  id="modal-form"
  (ngSubmit)="submitResult({ value: maxServPerc.value, poMandatory: slider.value })"
  class="o-grid--medium u-mt--medium">
  <div class="c-form-group o-grid__item col-12 col-sm-6">
    <label
      for="maxServPerc"
      class="c-form-label"
      >{{ localizationConstants.APPROVED_SERVICE_PRICE_MAX_SERVICE_PRICE | translate }}</label
    >
    <input
      #maxServPerc="ngModel"
      ngModel
      id="maxServPerc"
      name="maxServPerc"
      type="text"
      class="c-input c-input--alpha"
      required />
  </div>
  <div class="c-form-group o-grid__item col-12 col-sm-6">
    <label class="c-form-label">{{
      localizationConstants.APPROVED_SERVICE_PRICE_PO_MANDATORY | translate
    }}</label>
    <div>
      <input
        #slider="ngModel"
        ngModel
        type="checkbox"
        id="slider"
        name="slider"
        class="c-checkbox-slider" />
      <label
        for="slider"
        class="c-switch-slider--left"></label>
    </div>
  </div>
  <div class="o-grid__item col-offset-6 col-3 u-mt--medium u-tablet">
    <button
      type="button"
      class="button--sm button-secondary button-block"
      (click)="modalService.close()">
      {{ localizationConstants.BUTTON_CANCEL | translate }}
    </button>
  </div>
  <div class="o-grid__item col-12 col-md-3 u-mt--medium">
    <button
      type="submit"
      class="button--sm button-primary button-block"
      [disabled]="f.invalid">
      {{ localizationConstants.BUTTON_ADD | translate }}
    </button>
  </div>
</form>
